import React from 'react';
import { Box, SxProps, Theme } from '@mui/system';
import { RevampedIconPath } from '@askporter/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const SVGInject = require('@iconfu/svg-inject');

export interface RevampedIconProps {
  /**
   * The full icon path from media repo
   */
  fullPath: RevampedIconPath;
  /**
   * the data-testid
   */
  dataTestId?: string;
  /**
   * IconSize types, e.g. SM, MD or LG(Staying consistent with the mui sizes)
   */
  iconSize: RevampedIconSize;
  /**
   * 1st child(path) fill color
   */
  firstPathFill?: string;
  /**
   * 1st child(path) stroke color
   */
  firstPathStroke?: string;
  /**
   * 2nd child fill color
   */
  secondPathFill?: string;
  /**
   * 2nd child(path) stroke color
   */
  secondPathStroke?: string;
  /**
   * Custom styles for the svg
   */
  customSvgStyles?: SxProps<Theme>;
  /**
   * Additional content to be rendered inside the icon
   */
  additionalContent?: React.ReactNode;
}

/**
 * Renders an Icon from https://github.com/askporter/media/tree/main/media/icons
 */
export const RevampedIcon = ({
  fullPath,
  dataTestId,
  iconSize,
  firstPathFill,
  firstPathStroke,
  secondPathFill,
  secondPathStroke,
  customSvgStyles = {},
  additionalContent,
}: RevampedIconProps): JSX.Element => {
  return (
    <Box
      data-testid={dataTestId || `icon-${fullPath}`}
      sx={{
        position: 'relative',
        '& svg > path:first-of-type': {
          fill: firstPathFill,
          stroke: firstPathStroke,
        },
        '& svg > path:nth-of-type(2)': {
          fill: secondPathFill,
          stroke: secondPathStroke,
        },
        width: iconSize,
        height: iconSize,
        boxSizing: 'content-box',
        ...customSvgStyles,
      }}
    >
      <img
        src={fullPath}
        onLoad={(e) => {
          SVGInject(e.target);
        }}
        width={'100%'}
        height={'100%'}
        alt=""
      />
      {additionalContent}
    </Box>
  );
};

export enum RevampedIconSize {
  XS = '18px',
  SM = '20px',
  MD = '24px',
  LG = '28px',
  // XL = '32px', Not needed so far!
  XXL = '40px',
}
